/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Modal, { ModalHeader } from '../Modal';
import Form from '../Form';
import useForm from '../../hooks/useForm';
import { isEmpty } from '../../utils/lodashExtend';
import { addSubscriber, editSubscriber } from '../../apis/admin/newsletter';
import { toast } from '../../utils/toast';

const defaultForm = {
  name: "",
  email: "",
};

const Subscriber = ({ open, setOpen, selectedItem, setSelectedItem, submit, ...props }) => {
  const [fields] = useState([
    {
      key: "name",
      title: "이름",
      type: "input",
      required: true,
    },
    {
      key: "email",
      title: "이메일",
      type: "input",
      required: true,
      validators: ["email"]
    },
  ]);

  const [mode, setMode] = useState("create");


  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    submit && submit();
    if (setSelectedItem) {
      setSelectedItem(null);
    }
  };

  const _submit = (params) => {
    if (mode === "create") {
      addSubscriber(params)
        .then(res => {
          toast.success("등록이 완료되었습니다.");
          cancel();
          submit && submit();
        }).catch((err) => {
          console.error(err.response);
        });
    } else {
      editSubscriber(form.idx, params)
        .then(res => {
          toast.success("수정이 완료되었습니다.");
          cancel();
          submit && submit();
        }).catch((err) => {
          console.error(err.response);
        });

    }
  };

  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
    setValidateFields,
    setOriginForm,
  } = useForm(
    defaultForm,
    _submit,
  );

  useEffect(() => {
    setMode(selectedItem ? 'detail' : 'create');
    if (selectedItem) {
      setForm(selectedItem);
      setOriginForm(selectedItem);
    } else {
      setForm(defaultForm);
      setOriginForm(defaultForm);
    }
  }, [open, selectedItem]);

  useEffect(() => {
    if (!isEmpty(fields)) setValidateFields(fields);
  }, [fields]);



  return (
    <>
      <Modal
        isOpen={open}
        close={cancel}
      >
        <ModalHeader>
          {`구독자 ${mode === "create" ? "등록" : "정보 변경"}`}
        </ModalHeader>
        <Form
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          submitText={mode === "create" ? "등록" : "수정"}
          submit={handleSubmit}
          cancel={cancel}
        />
      </Modal>
    </>
  );
};

export default Subscriber;